import { Controller } from "react-hook-form";
import { Input } from "rsuite";
import { commonFormProps } from "../../../utils/typeDefs";

const InputText = ({
  title,
  inputName,
  errors,
  control,
  inputErrorMessage,
  defaultInput,
  placeholder,
  rules,
}: commonFormProps) => {
  return (
    <div className="row pb-2 form-input-field">
      <div className="col-12 col-md-3 my-auto">
        <p className="form-label">
          {title}: {errors && inputErrorMessage("Required")}
        </p>
      </div>
      <div className="col-12 col-md-9">
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              inputRef={field.ref}
              placeholder={placeholder}
            />
          )}
          defaultValue={defaultInput}
        />
      </div>
    </div>
  );
};

export default InputText;
